export const albums = [
  {
    album: "monument",
    name: "Monument",
    year: 2026,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    images: [1],
    series: "Cloud Play",
  },
  {
    album: "trellis",
    name: "Trellis",
    year: 2026,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    series: "Cloud Play",
  },
  {
    album: "arch_sculpture",
    name: "Arch Sculpture & Hanging Clouds",
    year: 2026,
    materials: "canvas, quilt batting, rigid foam, rebar, nuts & bolts, poly-fill",
    images: [1],
    series: "Cloud Play",
  },
  {
    album: "cloud_play_arch",
    name: "Cloud Play Arch",
    year: 2026,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    series: "Cloud Play",
  },
  {
    album: "black_windows",
    name: "Black Windows",
    year: 2026,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    images: [1],
    series: "Cloud Play",
  },
  {
    album: "pavillion",
    name: "Pavillion",
    year: 2026,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    images: [1, 2, 3, 4, 5, 6],
    series: "Cloud Play",
  },
  {
    album: "iso_cloud",
    name: "Iso Cloud",
    year: 2026,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    images: [1, 2, 3, 4, 5],
    series: "Cloud Play",
  },
  {
    album: "toppled_arch",
    name: "Toppled Arch",
    year: 2026,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    images: [1, 2, 3, 4, 5],
    series: "Cloud Play",
  },
  {
    album: "toxic_cloud",
    name: "Toxic Cloud",
    year: 2026,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    images: [1, 2, 3, 4, 5],
    series: "Cloud Play",
  },
  {
    album: "castle_cloud",
    name: "Castle Cloud",
    year: 2026,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    images: [1, 2, 3, 4, 5, 6],
    series: "Cloud Play",
  },
  {
    album: "stair_shadow_1",
    name: "Stair Shadow No. 1",
    year: 2025,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    series: "Shadows",
  },
  {
    album: "stair_shadow_2",
    name: "Stair Shadow No. 2",
    year: 2025,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    series: "Shadows",
  },
  {
    album: "cloud_colloseum",
    name: "Cloud Colloseum",
    year: 2025,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    series: "Clouds",
  },
  {
    album: "cloud_shadow_1",
    name: "Cloud Shadow No. 1",
    year: 2024,
    materials: "canvas & quilt batting",
    size: '18" x 26"',
    price: "sold",
    series: "Clouds",
  },
  {
    album: "cloud_shadow_2",
    name: "Cloud Shadow No. 2",
    year: 2024,
    materials: "canvas & quilt batting",
    size: '18" x 26"',
    series: "Clouds",
  },
  {
    album: "cloud_shadow_3",
    name: "Cloud Shadow No. 3",
    year: 2024,
    materials: "canvas & quilt batting",
    size: '18" x 26"',
    series: "Clouds",
  },
  {
    album: "zig_zag",
    name: "Zig Zag",
    year: 2024,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    series: "Shadows",
  },
  {
    album: "arched_interior",
    name: "Arched Interior",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '12" x 12"',
    price: "sold",
    series: "Arches",
  },
  {
    album: "green_door",
    name: "Green Door",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '12" x 12"',
    series: "New Mexico",
  },
  {
    album: "double_green_door",
    name: "Double Green Door",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '12" x 12"',
    series: "New Mexico",
  },
  {
    album: "adobe_gate",
    name: "Adobe Gate",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '12" x 12"',
    price: "sold",
    series: "New Mexico",
  },
  {
    album: "castle_window",
    name: "Castle Window",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: 300,
    series: "Arches",
  },
  {
    album: "white_sands_dune",
    name: "White Sands Dune",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '12" x 12"',
    price: "sold",
    series: "New Mexico",
  },
  {
    album: "face_no_1",
    name: "Face No. 1",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '14" x 14"',
    price: "sold",
    series: "Faces",
  },
  {
    album: "face_no_2",
    name: "Face No. 2",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '14" x 14"',
    price: 350,
    series: "Faces",
  },
  {
    album: "face_no_3",
    name: "Face No. 3",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '14" x 14"',
    price: 350,
    series: "Faces",
  },
  {
    album: "doorway_light",
    name: "Doorway Light",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '28.5" x 34"',
    price: "sold",
    series: "Shadows",
  },
  {
    album: "shadow_abstraction_1",
    name: "Shadow Abstraction No. 1",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: "sold",
    series: "Shadows",
  },
  {
    album: "shadow_abstraction_2",
    name: "Shadow Abstraction No. 2",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: "sold",
    series: "Shadows",
  },
  {
    album: "shadow_abstraction_3",
    name: "Shadow Abstraction No. 3",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: 600,
    images: [1, 2, 3],
    series: "Shadows",
  },
  {
    album: "arched_stairway",
    name: "Arched Stairway",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '17.5" x 13"',
    price: "sold",
    series: "Arches",
  },
  {
    album: "arch_shadow",
    name: "Arch Shadow",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: 600,
    series: "Arches",
  },
  {
    album: "cloud_field",
    name: "Cloud Fields",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: 900,
    images: [1, 2, 3],
    series: "Clouds",
  },
  {
    album: "gateways",
    name: "Gateways",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '14" x 14"',
    price: 300,
    series: "Arches",
  },
  {
    album: "9_three_columns_2022",
    name: "Three Columns",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: 300,
    series: "Horizons",
  },
  {
    album: "6_triple_arch_2022",
    name: "Triple Arch",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: "sold",
    series: "Arches",
  },
  {
    album: "7_iso_square_2022",
    name: "Isometric Square No. 2",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: "sold",
    series: "Horizons",
  },
  {
    album: "10_walled_arch_2022",
    name: "Walled Arch",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: 300,
    series: "Arches",
  },
  {
    album: "8_view_point_2022",
    name: "View Point",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: "sold",
    series: "Horizons",
  },
  {
    album: "5_large_arch_2022",
    name: "Large Arch",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: "sold",
    series: "Arches",
  },
  {
    album: "4_columns_2022",
    name: "Columns",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '17" x 25"',
    price: 350,
    series: "Horizons",
  },
  {
    album: "3_arches_2022",
    name: "Arches",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '12" x 23"',
    price: 300,
    series: "Arches",
  },
  {
    album: "2_faces_2021",
    name: "Faces",
    year: 2021,
    materials: "canvas & quilt batting",
    size: '14" x 14"',
    price: "sold",
    series: "Faces",
  },
  {
    album: "1_square_2020",
    name: "Isometric Square No. 1",
    year: 2020,
    materials: "canvas & quilt batting",
    size: '12" x 15"',
    price: "sold",
    series: "Horizons",
  },
];

const SERIES_ORDER = [
  "Cloud Play",
  "Clouds",
  "Shadows",
  "Arches",
  "Horizons",
  "New Mexico",
  "Faces",
];

export const getSeriesWorks = (series) =>
  albums
    .filter((a) => a.series === series)
    .slice()
    .sort((a, b) => b.year - a.year);

export const getSeriesIndex = () => {
  const names = new Set(albums.map((a) => a.series));
  const ordered = SERIES_ORDER.filter((s) => names.has(s)).concat(
    Array.from(names).filter((s) => SERIES_ORDER.indexOf(s) < 0)
  );
  return ordered.map((name) => {
    const works = getSeriesWorks(name);
    return { name, cover: works[0].album, count: works.length };
  });
};
